import React, { useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogContent, DialogTitle, FormControl, MenuItem, Select } from '@mui/material';
import { Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import axios from 'axios';
import * as yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { FormError } from '~/components/form/FormError';
import { PresetAutocomplete } from '../PresetAutocomplete';
const formSchema = yup
    .object({
    goal: yup.string().required('Goal is required'),
    metric: yup.string().required('Metric is required'),
    initialVal: yup.string().required('Initial is required'),
    target: yup.string().required('Target is required'),
    prognosis: yup.string().required('Prognosis is required'),
    goalDescription: yup.string().nullable()
})
    .required();
export const AddPatientGoalModal = (props) => {
    const { onRequestClose, itemToEdit, patientId, onSuccess } = props;
    const [isSubmitting, setIsSubmitting] = useState(false);
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            goal: itemToEdit ? itemToEdit.goal : '',
            metric: itemToEdit ? itemToEdit.metric : '',
            initialVal: itemToEdit ? itemToEdit.initial : '',
            target: itemToEdit ? itemToEdit.target : '',
            prognosis: itemToEdit ? itemToEdit.prognosis : '',
            goalDescription: itemToEdit ? itemToEdit.goalDescription : ''
        },
    });
    const { formState: { errors }, handleSubmit, register, } = methods;
    const onFormSubmit = async ({ goal, metric, initialVal, target, prognosis, goalDescription }) => {
        setIsSubmitting(true);
        console.log('submitting');
        const data = {
            goal: goal == '' ? null : goal,
            metric: metric == '' ? null : metric,
            initialVal: initialVal == '' ? null : initialVal,
            target: target == '' ? null : target,
            prognosis: prognosis == '' ? null : prognosis,
            goalDescription: goalDescription == '' ? null : goalDescription
        };
        console.log(data);
        if (itemToEdit) {
            const response = await axios.post('/api/carePlan/editPatientGoal', {
                goalId: itemToEdit.id,
                goal: data.goal,
                metric: data.metric,
                initial: data.initialVal,
                target: data.target,
                prognosis: data.prognosis,
                goalDescription: data.goalDescription
            });
            const new_goal = response.data.data.new_goal;
            const updatedGoal = {
                id: new_goal.id,
                patientId: new_goal.patient_id,
                carePlanId: new_goal.care_plan_id,
                goal: new_goal.goal,
                metric: new_goal.metric,
                initial: new_goal.initial,
                target: new_goal.target,
                prognosis: new_goal.prognosis,
                goalDescription: new_goal.goal_description,
                updatedAt: new Date(new_goal.updated_at),
                deletedAt: new Date(new_goal.deleted_at),
                createdAt: new Date(new_goal.created_at),
                isEditable: new_goal.is_editable,
                month: new_goal.month
            };
            onSuccess(updatedGoal);
        }
        else {
            const response = await axios.post('/api/carePlan/addPatientGoal', {
                patientId: patientId,
                goal: data.goal,
                metric: data.metric,
                initial: data.initialVal,
                target: data.target,
                prognosis: data.prognosis,
                goalDescription: data.goalDescription
            });
            const new_goal = response.data.data.new_goal;
            const updatedGoal = {
                id: new_goal.id,
                patientId: new_goal.patient_id,
                carePlanId: new_goal.care_plan_id,
                goal: new_goal.goal,
                metric: new_goal.metric,
                initial: new_goal.initial,
                target: new_goal.target,
                prognosis: new_goal.prognosis,
                goalDescription: new_goal.goal_description,
                updatedAt: new Date(new_goal.updated_at),
                deletedAt: new Date(new_goal.deleted_at),
                createdAt: new Date(new_goal.created_at),
                isEditable: new_goal.is_editable,
                month: new_goal.month
            };
            onSuccess(updatedGoal);
        }
        setIsSubmitting(false);
    };
    const presetsByField = useMemo(() => {
        return props.presets.reduce((acc, preset) => {
            (acc[preset.field] ||= []).push(preset);
            return acc;
        }, {});
    }, [props.presets]);
    return (React.createElement(Dialog, { open: true, PaperProps: {
            sx: { maxHeight: '60vh', maxWidth: '50%', width: '50%' }
        } },
        React.createElement(DialogTitle, { sx: {
                m: 0, p: 2, display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }, id: "customized-dialog-title" },
            itemToEdit ? 'Edit Goal' : 'Add Goal',
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { marginLeft: 'auto', marginRight: 'auto', width: '70%' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Goal"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "goal", presets: presetsByField['goal'], category: "goal", field: "goal", placeholder: "e.g., Improve Glycemic Control" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Metric"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "metric", presets: presetsByField['metric'], category: "goal", field: "metric", placeholder: "e.g., TIR" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Baseline"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "initialVal", presets: presetsByField['baseline'], category: "goal", field: "baseline", placeholder: "e.g., 45%" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Target"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(PresetAutocomplete, { name: "target", presets: presetsByField['target'], category: "goal", field: "target", placeholder: "e.g., >70%" })),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Prognosis"),
                                React.createElement("div", { className: "row" },
                                    React.createElement(FormControl, { fullWidth: true, size: "small" },
                                        React.createElement(Select, { ...register('prognosis', {
                                                required: 'Prognosis is required',
                                            }), defaultValue: itemToEdit ? itemToEdit.prognosis : '', displayEmpty: true },
                                            React.createElement(MenuItem, { value: "", disabled: true }, "Select a prognosis"),
                                            React.createElement(MenuItem, { value: "Meeting Goal" }, "Meeting Goal"),
                                            React.createElement(MenuItem, { value: "Improving" }, "Improving"),
                                            React.createElement(MenuItem, { value: "Needs Support" }, "Needs Support"),
                                            React.createElement(MenuItem, { value: "Barriers Present" }, "Barriers Present")))),
                                React.createElement("br", null),
                                React.createElement("div", { style: { width: '100%', color: '#121417', fontSize: 14, fontFamily: 'Barlow', fontWeight: '500' } }, "Description/Notes"),
                                React.createElement("div", { className: "row" },
                                    React.createElement("textarea", { className: 'problem-list-scroll', onKeyDown: (event) => event.stopPropagation(), style: {
                                            fontFamily: 'Barlow',
                                            verticalAlign: 'top',
                                            overflowY: 'scroll',
                                            height: '85px',
                                            padding: '10px',
                                            width: '100%',
                                            borderWidth: '1px',
                                            borderColor: '#B9B9B9',
                                            borderRadius: '4px'
                                        }, placeholder: 'Enter Notes', ...register('goalDescription'), defaultValue: itemToEdit?.goalDescription ?? '' })),
                                React.createElement(FormError, { errors: errors, name: "add-problem" })))),
                    React.createElement("div", { className: "flex justify-between items-center" },
                        React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: isSubmitting, type: "submit", color: "primary" }, itemToEdit ? 'Edit Goal' : 'Add Goal')))))));
};
